'use strict';

var react = require('@emotion/react');

const price = /*#__PURE__*/ react.css({
    marginTop: "auto",
    paddingBottom: "4px"
}, "label:label-Price-web-stylesprice", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL3BsYXRmb3JtL1Byb2R1Y3RDYXJkL1ByaWNlL1ByaWNlLndlYi5zdHlsZXMudHMiLCJzb3VyY2VzIjpbIi9idWlsZHMvZGV2ZWxvcGVycy9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9wbGF0Zm9ybS9Qcm9kdWN0Q2FyZC9QcmljZS9QcmljZS53ZWIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgcHJpY2UgPSBjc3Moe1xuICBtYXJnaW5Ub3A6IFwiYXV0b1wiLFxuICBwYWRkaW5nQm90dG9tOiBcIjRweFwiLFxufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXFCIn0= */");

exports.price = price;
//# sourceMappingURL=Price.web.styles.cjs.map
